export const XY_API_ENDPOINT = 'https://aggregator-api.xy.finance/v1';
export const XY_NATIVE_ADDRESS = '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee';
export const XY_AFFILIATE_ADDRESS = '0xcb022eba97b53f74e0901618252682f0728cd192';
